/**
 * Service: flexpay
 */
angular.module('acme.common.service.flexpay', [
  'acme.common.service.helpers',
  'acme.common.service.calendar',
  'acme.common.service.templates.helpers'
])
.service('FlexpayService', ['$filter', 'TemplatesHelpersService', 'HelpersService', 'CalendarService', function($filter, TemplatesHelpersService, HelpersService, CalendarService) {

    return {

      model: {},

      createHour: TemplatesHelpersService.createHour,
      createRange: TemplatesHelpersService.createRange,
      hourToDate: TemplatesHelpersService.hourToDate,
      types: TemplatesHelpersService.getFlexpayTypes(),
      getFlexpayType: TemplatesHelpersService.getFlexpayType,

      init: function(model) {
        this.model = model;
      },

      createSchedule: function(scheduleStartTime) {

        var index,
            hour = this.createHour(),
            range = this.createRange(),
            sDate = (scheduleStartTime) ? new Date(scheduleStartTime) : this.hourToDate(hour),
            startTime = sDate.setHours(12),
            endTime = sDate.setHours(13);

        return {
          name: '',
          effectiveStartTime: CalendarService.toISO8601(startTime),
          effectiveEndTime: CalendarService.toISO8601(endTime),
          type: this.types[0].value,
          repeatCycle: 'never',
          weekdays: [],
          range: range,
          monthly: [],
          daysOfMonth: [],
          days: [CalendarService.toYMDDate(sDate)]
        };

      },

      hasSchedules: function() {
        return (this.model.flexPays && this.model.flexPays instanceof Array && this.model.flexPays.length);
      },

      addSchedule: function(schedule) {
        // All new schedules are unshifted to the array with a NEW property
        schedule.NEW = true;
        if (!this.model.flexPays || !(this.model.flexPays instanceof Array)) {
          this.model.flexPays = [];
        }
        this.model.flexPays.unshift(schedule);
        return schedule;
      },

      removeSchedule: function(index) {
        if (this.hasSchedules()) {
          this.model.flexPays.splice(index, 1);
        }
      },

      getNewSchedule: function() {
        var i, ii,
          r = false;

        if (this.hasSchedules()) {
          for (i=0,ii=this.model.flexPays.length;i<ii;i++) {
            if (this.model.flexPays[i].hasOwnProperty('NEW')) {
              r = {
                index: i,
                schedule: this.model.flexPays[i]
              };
              break;
            }
          }
        }

        if (!r) {
          // New schedule is unshifted so index is 0
          r = {};
          r.index = 0;
          r.schedule = this.addSchedule(this.createSchedule());
        }

        return r;
      },

      removeNewSchedule: function() {
        this.model.flexPays.splice(this.getNewSchedule().index, 1);
      },

      setSchedule: function(schedule) {
        if (schedule && schedule.id) {
          this.model.flexPays[this.getScheduleById(schedule.id).index] = schedule;
        }else if (schedule.hasOwnProperty('NEW')) {
          this.model.flexPays[this.getNewSchedule().index] = schedule;
        }else{
          this.addSchedule(schedule);
        }
      },

      getSchedulesList: function() {
        var schedules = [];

        if (this.hasSchedules()) {
          schedules = this.processSchedules();
        }
        return schedules;
      },

      getScheduleById: function(id) {
        var i, ii,
          r = false;

        if (id && this.hasSchedules()) {
          for (i=0,ii=this.model.flexPays.length;i<ii;i++) {
            if (this.model.flexPays[i].id === id) {
              r = {
                index: i,
                schedule: this.model.flexPays[i]
              };
              break;
            }
          }
        }

        return r;
      },

      removeScheduleById: function(id) {
        this.model.flexPays.splice(this.getScheduleById(id).index, 1);
      },

      getScheduleRangeHours: function(schedule) {
        var range,
            ranges = [];

        if (schedule && schedule.range) {
          ranges.push({
            start: this.hourToDate(schedule.range.start),
            end: this.hourToDate(schedule.range.end)
          });
        }else{
          range = this.createRange();
          ranges.push({
            start: this.hourToDate(range.start),
            end: this.hourToDate(range.end)
          });
        }

        return ranges;
      },

      processScheduleRange: function(range) {
        var r = '';

        r += $filter('date')(this.hourToDate(range.start), HelpersService.dateFormats.standardTime);
        r += ' - ';
        r += $filter('date')(this.hourToDate(range.end), HelpersService.dateFormats.standardTime);

        return r;
      },

      processSchedules: function() {
        var i, ii,
            effectiveDates,
            schedules = [];

        for (i=0,ii=this.model.flexPays.length;i<ii;i++) {

          effectiveDates = TemplatesHelpersService.getEffectiveDates(this.model.flexPays[i].effectiveStartTime, this.model.flexPays[i].effectiveEndTime);

          schedules.push({
            id: this.model.flexPays[i].id,
            name: this.model.flexPays[i].name,
            type: this.getFlexpayType(this.types, this.model.flexPays[i].type).label,
            hours: this.processScheduleRange(this.model.flexPays[i].range),
            repeatCycle: TemplatesHelpersService.getRepeatType(TemplatesHelpersService.getRepeatTypes(), this.model.flexPays[i].repeatCycle).label,
            effectiveDates: effectiveDates
          });
        }

        return schedules;

      },

      verifySchedules: function() {
        var i, ii;

        if (this.hasSchedules()) {

          // Migrate start dates to all flexPays
          for (i=0,ii=this.model.flexPays.length;i<ii;i++) {
            // Copy temporary weekday values
            if (this.model.flexPays[i].repeatCycle === 'month') {
              if (this.model.flexPays[i].daysOfMonth instanceof Array &&
                this.model.flexPays[i].daysOfMonth.length > 0) {
                this.model.flexPays[i].monthly = null;
                delete this.model.flexPays[i].monthly;

                this.model.flexPays[i].weekdays = null;
                delete this.model.flexPays[i].weekdays;

              } else if (this.model.flexPays[i].monthly instanceof Array &&
                this.model.flexPays[i].monthly.length > 0) {
                this.model.flexPays[i].daysOfMonth = null;
                delete this.model.flexPays[i].daysOfMonth;
              }
            } else {
              this.model.flexPays[i].monthly = null;
              delete this.model.flexPays[i].monthly;

              this.model.flexPays[i].daysOfMonth = null;
              delete this.model.flexPays[i].daysOfMonth;

              // Include a days object if event never repeats
              if (this.model.flexPays[i].repeatCycle === 'never') {
                this.model.flexPays[i].days = [CalendarService.toYMDDate(CalendarService.parseDate(this.model.flexPays[i].effectiveStartTime))];
              }else{
                this.model.flexPays[i].days = null;
                delete this.model.flexPays[i].days;
              }
            }
          }

          this.verifyScheduleRanges();
        }
      },

      verifyScheduleRanges: function() {
        var i, ii;
        for (i=0,ii=this.model.flexPays.length;i<ii;i++) {
          if (!this.model.flexPays[i].range) {
            this.model.flexPays[i].ranges = this.createRange();
          }
        }
      }


    };

}]);